import { render, staticRenderFns } from "./ResturantsMobile.vue?vue&type=template&id=2cd21999"
import script from "./ResturantsMobile.vue?vue&type=script&lang=js"
export * from "./ResturantsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports